import logo from './logo.svg';
import './App.css';
import { useSelector } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import NavBar from './core/Navbar';
import Home from './home/Home';
import Login from './auth/Login';
import TrackerDashBoard from './tracker/TrackerDashboard';
import TrilhaBuilder from './trilhas/TrilhaBuilder';
import NovaTrilhaPage from './trilhas/NovaTrilhaPage';
import ContentsDashboard from './contents/ContentsDashboard';
import AdicionarContentPage from './contents/AdicionarContentPage';
import { Grid } from '@mui/joy';
import MediasDashboard from './medias/MediasDashboard';
import AdicionarMediaPage from './medias/AdicionarMediaPage';
import BadgeBuilder from './badges/BadgeBuilder';

function App() {
  var authenticated = useSelector((state) => state.auth.estaAutenticado)
  var serverBasename = typeof (window.serverBasename) != "undefined" ? window.serverBasename : "";
  return (
    <BrowserRouter basename={serverBasename}>
      {authenticated && <NavBar />}
      {/* <GeneralErrorDialog /> */}
      {/* <ConfirmationModal /> */}
      {/* <GeneralDetailsDialog /> */}
      {/* {authenticated && <Timertracker />} */}

      <Grid container sx={{ padding: "10px" }}>
        <Routes>
          <Route path="/" element={
            <PrivateRoute component={() => <Home />} auth={authenticated} />
          } />
          <Route path="/medias" element={
            <PrivateRoute component={() => <MediasDashboard />} auth={authenticated} />
          } />
          <Route path="/medias/adicionar" element={
            <PrivateRoute component={() => <AdicionarMediaPage />} auth={authenticated} />
          } />
          <Route path="/contents" element={
            <PrivateRoute component={() => <ContentsDashboard />} auth={authenticated} />
          } />
          <Route path="/contents/adicionar" element={
            <PrivateRoute component={() => <AdicionarContentPage />} auth={authenticated} />
          } />
          <Route path="/trilha-builder" element={
            <PrivateRoute component={() => <TrilhaBuilder />} auth={authenticated} />
          } />
          <Route path="/trilha-builder/nova" element={
            <PrivateRoute component={() => <NovaTrilhaPage />} auth={authenticated} />
          } />
          <Route path="/tracker" element={
            <PrivateRoute component={() => <TrackerDashBoard />} auth={authenticated} />
          } />
          <Route path="/badges" element={
            <PrivateRoute component={() => <BadgeBuilder />} auth={authenticated} />
          } />
          <Route path="/login" element={<Login />} />
        </Routes>
      </Grid>
    </BrowserRouter>
  )
}

const PrivateRoute = ({ component: Component, auth: auth, ...rest }) => {
  if (auth) {
    return <Component {...rest} />
  } else {
    return <Navigate to={{
      pathname: '/login',
      state: { from: rest.location }
    }} />
  }

};

export default App;